import PropTypes from "prop-types";

export const ReminderPropTypes = {
  message: PropTypes.string,
  remind_at: PropTypes.number,
  id: PropTypes.number,
  send_email: PropTypes.bool,
  send_push: PropTypes.bool,
  reminder_sent: PropTypes.bool,
  task_id: PropTypes.number,
  oid: PropTypes.number,
};

export const ReminderShapePropTypes = PropTypes.shape(ReminderPropTypes);
